export const getEnvVaribles = () => {
    return {
      MODE: process.env.REACT_APP_CLIENT_ID,
      API_URL: process.env.REACT_APP_BASE_URL,
      RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
      RECAPTCHA_SECRET_KEY: process.env.REACT_APP_RECAPTCHA_SECRET_KEY
    };
};